// extracted by mini-css-extract-plugin
module.exports = {"court_details_container":"XuQlxsh","company_directorships_table":"_2GRDp6D"};